import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { ProcessDraftNoteSchema, NoteCategorySchema, NoteGeometrySchema, NoteTargetsSchema } from '../../entities/process-note';
// --- Add Draft Note ---
// POST /api/v2/process/:processId/draft/notes
export const AddDraftNoteRequestSchema = z.object({
    text: z.string(),
    category: NoteCategorySchema,
    geometry: NoteGeometrySchema,
    targets: NoteTargetsSchema
});
export const DraftNoteResponseSchema = z.object({
    note: ProcessDraftNoteSchema
});
// --- Update Draft Note (content) ---
// PATCH /api/v2/process/:processId/draft/notes/:noteId
export const UpdateDraftNoteRequestSchema = z.object({
    text: z.string().optional(),
    category: NoteCategorySchema.optional()
});
// --- Place Draft Note (move / resize / re-target) ---
// PATCH /api/v2/process/:processId/draft/notes/:noteId/placement
export const PlaceDraftNoteRequestSchema = z.object({
    geometry: NoteGeometrySchema.optional(),
    targets: NoteTargetsSchema.optional()
});
// --- Delete Draft Note ---
// DELETE /api/v2/process/:processId/draft/notes/:noteId
export const DeleteDraftNoteResponseSchema = z.object({
    deletedNoteId: ObjectIdSchema
});

//# sourceMappingURL=process-notes.schema.js.map